export { default as DetailsSection } from './details-section';
